import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function QueuedIcon({
  className,
  fill = IconColors.DarkGrey,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 16}
      viewBoxDimensions="0 0 16 16"
      width={width ?? 16}
    >
      <path
        d="M7.08125 7.7625a0.28750000000000003 0.28750000000000003 0 0 0 0.06875 -0.25 0.30625 0.30625 0 0 0 -0.1375 -0.21250000000000002 4.66875 4.66875 0 0 0 -2.5 -0.7374999999999999A4.71875 4.71875 0 0 0 0 9.9125a0.3125 0.3125 0 0 0 0.05 0.275 0.3 0.3 0 0 0 0.25 0.125h5.4125a0.30625 0.30625 0 0 0 0.30625 -0.25625 5.0375000000000005 5.0375000000000005 0 0 1 1.0625 -2.29375Z"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="M1.40625 2.96875a2.96875 2.96875 0 1 0 5.9375 0 2.96875 2.96875 0 1 0 -5.9375 0"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="M10.9375 6.875a4.0625 4.0625 0 1 0 4.0625 4.0625 4.06875 4.06875 0 0 0 -4.0625 -4.0625Zm0 6.875a2.8125 2.8125 0 1 1 2.8125 -2.8125 2.8187499999999996 2.8187499999999996 0 0 1 -2.8125 2.8125Z"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="M12.1875 10.3125h-0.46875a0.15625 0.15625 0 0 1 -0.15625 -0.15625v-0.625a0.625 0.625 0 0 0 -1.25 0v1.40625a0.625 0.625 0 0 0 0.625 0.625h1.25a0.625 0.625 0 0 0 0 -1.25Z"
        fill={fill}
        strokeWidth="1"
      />
    </SimpleIcon>
  );
}
